// import React, { Suspense, lazy, useState, useEffect, memo } from "react";
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Navigate,
//   Outlet,
// } from "react-router-dom";

// import AppNavbar from "./componets/Navbar.jsx";
// import Footer from "./componets/Footer";
// import ScrollToTop from "./componets/ScrollToTop";

// import AdminDashboard from "./pages/Admin/AdminDashboard.jsx";
// import Login from "./pages/Admin/Login.jsx";

// /* -------------------- Lazy Pages -------------------- */
// const Home = lazy(() => import("./pages/Home.jsx"));
// const Contact = lazy(() => import("./pages/Contact"));
// const AboutPage = lazy(() => import("./pages/AboutPage.jsx"));
// const ServicesPage = lazy(() => import("./pages/ServicesPage"));
// const ProjectsPage = lazy(() => import("./pages/ProjectsPage"));
// const GalleryPage = lazy(() => import("./pages/GalleryPage"));
// const CareersPage = lazy(() => import("./pages/CareersPage"));

// /* -------------------- Private Route -------------------- */
// const PrivateRoute = () => {
//   const isAuthenticated = Boolean(localStorage.getItem("admin_token"));
//   return isAuthenticated ? <Outlet /> : <Navigate to="/admin/login" replace />;
// };

// /* -------------------- Loading Spinner -------------------- */
// const LoadingSpinner = memo(() => (
//   <div
//     className="d-flex justify-content-center align-items-center"
//     style={{ height: "60vh" }}
//   >
//     <div
//       className="spinner-border text-primary"
//       role="status"
//       style={{ width: "3rem", height: "3rem" }}
//     >
//       <span className="visually-hidden">Loading...</span>
//     </div>
//   </div>
// ));

// /* -------------------- Shared Page Layout -------------------- */
// const PageLayout = memo(({ title, children }) => (
//   <div className="container py-5 mt-5">
//     <h1 className="fw-bold" style={{ marginTop: "3%", color: "#0062A0" }}>
//       {title}
//     </h1>

//     <hr
//       style={{
//         width: "50px",
//         height: "3px",
//         backgroundColor: "#E91E63",
//         border: "none",
//         opacity: 1,
//       }}
//     />

//     {children}
//   </div>
// ));

// /* -------------------- Main App -------------------- */
// function App() {
//   const [apiData, setApiData] = useState(null);

//   useEffect(() => {
//     const fetchGlobalData = async () => {
//       try {
//         const response = await fetch(
//           "https://radheyelectrical.com/api/api_handler.php"
//         );

//         const json = await response.json();

//         if (json.status === "success") {
//           setApiData(json.data);
//         }
//       } catch (error) {
//         console.error("Global API fetch error:", error);
//       }
//     };

//     fetchGlobalData();
//   }, []);

//   return (
//     <Router>
//       <ScrollToTop />

//       {/* Navbar */}
//       <AppNavbar
//         contactInfo={apiData?.contact_info || []}
//         socialLinks={apiData?.social_link || []}
//       />

//       <main style={{ marginTop: "80px" }}>
//         <Suspense fallback={<LoadingSpinner />}>
//           <Routes>
//             {/* Public Routes */}
//             <Route path="/" element={<Home />} />

//             <Route
//               path="/about"
//               element={
//                 <PageLayout title="About Us">
//                   <AboutPage />
//                 </PageLayout>
//               }
//             />

//             <Route
//               path="/services"
//               element={
//                 <PageLayout title="Our Services">
//                   <ServicesPage />
//                 </PageLayout>
//               }
//             />

//             <Route
//               path="/projects"
//               element={
//                 <PageLayout title="Our Projects">
//                   <ProjectsPage />
//                 </PageLayout>
//               }
//             />

//             <Route
//               path="/gallery"
//               element={
//                 <PageLayout title="Gallery">
//                   <GalleryPage />
//                 </PageLayout>
//               }
//             />

//             <Route
//               path="/careers"
//               element={
//                 <PageLayout title="Careers">
//                   <CareersPage />
//                 </PageLayout>
//               }
//             />

//             <Route path="/contact" element={<Contact />} />

//             {/* Admin Login */}
//             <Route path="/admin/login" element={<Login />} />

//             {/* Private Admin Routes */}
//             <Route element={<PrivateRoute />}>
//               <Route path="/admin/dashboard" element={<AdminDashboard />} />
//             </Route>
//           </Routes>
//         </Suspense>
//       </main>

//       {/* Footer */}
//       <Footer
//         partners={apiData?.partner || []}
//         footerServices={apiData?.footer_service || []}
//         locations={apiData?.location || []}
//       />
//     </Router>
//   );
// }

// export default App;
import React, { Suspense, lazy, useState, useEffect, memo } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
  Link, // Added Link for the 404 "Go Home" button
} from "react-router-dom";

import AppNavbar from "./componets/Navbar.jsx";
import Footer from "./componets/Footer";
import ScrollToTop from "./componets/ScrollToTop";

import AdminDashboard from "./pages/Admin/AdminDashboard.jsx";
import Login from "./pages/Admin/Login.jsx";

/* -------------------- Lazy Pages -------------------- */
const Home = lazy(() => import("./pages/Home.jsx"));
const Contact = lazy(() => import("./pages/Contact"));
const AboutPage = lazy(() => import("./pages/AboutPage.jsx"));
const ServicesPage = lazy(() => import("./pages/ServicesPage"));
const ProjectsPage = lazy(() => import("./pages/ProjectsPage"));
const GalleryPage = lazy(() => import("./pages/GalleryPage"));
const CareersPage = lazy(() => import("./pages/CareersPage"));

/* -------------------- 404 Not Found Component -------------------- */
const NotFound = () => {
  return (
    <div
      className="container-fluid min-vh-100 d-flex align-items-center justify-content-center"
      style={{
        backgroundColor: "#f4f7f9",
        backgroundImage: "radial-gradient(#d1d9e0 1px, transparent 1px)",
        backgroundSize: "40px 40px",
        position: "relative",
      }}
    >
      {/* Technical HUD Decorations */}
      <div
        className="position-absolute top-0 start-0 p-4 d-none d-md-block"
        style={{ color: "#0062A0", opacity: 0.3, fontFamily: "monospace" }}
      >
        <div>SYS.STATUS: 404_NOT_FOUND</div>
        <div>COORD: 23.0225° N, 72.5714° E</div>
      </div>

      <style>
        {`
          @keyframes scanline {
            0% { transform: translateY(-100%); }
            100% { transform: translateY(1000%); }
          }
          @keyframes blink {
            0%, 100% { opacity: 1; }
            50% { opacity: 0; }
          }
          .blueprint-card {
            background: white;
            border: 2px solid #0062A0;
            border-radius: 0px;
            padding: 3rem;
            position: relative;
            box-shadow: 15px 15px 0px rgba(0, 98, 160, 0.1);
          }
          .scan-effect {
            position: absolute;
            top: 0; left: 0; width: 100%; height: 5px;
            background: rgba(0, 98, 160, 0.1);
            animation: scanline 4s linear infinite;
          }
          .corner {
            position: absolute;
            width: 20px; height: 20px;
            border: 3px solid #E91E63;
          }
        `}
      </style>

      <div
        className="blueprint-card text-center"
        style={{ maxWidth: "550px", width: "90%" }}
      >
        <div className="scan-effect"></div>

        {/* Decorative Corners */}
        <div
          className="corner"
          style={{
            top: "-10px",
            left: "-10px",
            borderRight: 0,
            borderBottom: 0,
          }}
        ></div>
        <div
          className="corner"
          style={{
            bottom: "-10px",
            right: "-10px",
            borderLeft: 0,
            borderTop: 0,
          }}
        ></div>

        {/* Graphic: Warning Triangle with Bolt */}
        <div className="mb-4">
          <svg
            width="100"
            height="100"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#E91E63"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13" strokeWidth="2"></line>
            <line x1="12" y1="17" x2="12.01" y2="17" strokeWidth="2"></line>
          </svg>
        </div>

        <h1
          className="fw-bold display-4"
          style={{ color: "#0062A0", letterSpacing: "5px" }}
        >
          ERROR <span style={{ color: "#E91E63" }}>404</span>
        </h1>

        <div className="d-flex align-items-center justify-content-center my-3">
          <div
            style={{
              height: "2px",
              flex: 1,
              backgroundColor: "#0062A0",
              opacity: 0.2,
            }}
          ></div>
          <span
            className="mx-3 fw-bold text-muted small"
            style={{ letterSpacing: "2px" }}
          >
            TERMINAL DISCONNECTED
          </span>
          <div
            style={{
              height: "2px",
              flex: 1,
              backgroundColor: "#0062A0",
              opacity: 0.2,
            }}
          ></div>
        </div>

        <p className="text-secondary mb-4 px-lg-4">
          The circuit path for <strong>{window.location.pathname}</strong>{" "}
          returned a null response. The requested module is either missing or
          has been decommissioned.
        </p>

        <Link
          to="/"
          className="btn rounded-0 px-5 py-3 shadow-sm"
          style={{
            backgroundColor: "#0062A0",
            color: "white",
            border: "none",
            fontWeight: "bold",
            letterSpacing: "1px",
            transition: "all 0.3s",
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = "#E91E63";
            e.target.style.transform = "translate(-3px, -3px)";
            e.target.style.boxShadow = "8px 8px 0px #0062A0";
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = "#0062A0";
            e.target.style.transform = "translate(0, 0)";
            e.target.style.boxShadow = "none";
          }}
        >
          Return To HOME
        </Link>

        <div className="mt-4" style={{ animation: "blink 1.5s infinite" }}>
          <small className="text-muted fw-bold">STATUS: STANDBY...</small>
        </div>
      </div>
    </div>
  );
};
/* -------------------- Private Route -------------------- */
const PrivateRoute = () => {
  const isAuthenticated = Boolean(localStorage.getItem("admin_token"));
  return isAuthenticated ? <Outlet /> : <Navigate to="/admin/login" replace />;
};

/* -------------------- Loading Spinner -------------------- */
const LoadingSpinner = memo(() => (
  <div
    className="d-flex justify-content-center align-items-center"
    style={{ height: "60vh" }}
  >
    <div
      className="spinner-border text-primary"
      role="status"
      style={{ width: "3rem", height: "3rem" }}
    >
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
));

/* -------------------- Shared Page Layout -------------------- */
const PageLayout = memo(({ title, children }) => (
  <div className="container py-5 mt-5">
    <h1 className="fw-bold" style={{ marginTop: "3%", color: "#0062A0" }}>
      {title}
    </h1>

    <hr
      style={{
        width: "50px",
        height: "3px",
        backgroundColor: "#E91E63",
        border: "none",
        opacity: 1,
      }}
    />

    {children}
  </div>
));

/* -------------------- Main App -------------------- */
function App() {
  const [apiData, setApiData] = useState(null);

  useEffect(() => {
    const fetchGlobalData = async () => {
      try {
        const response = await fetch(
          "https://radheyelectrical.com/api/api_handler.php"
        );

        const json = await response.json();

        if (json.status === "success") {
          setApiData(json.data);
        }
      } catch (error) {
        console.error("Global API fetch error:", error);
      }
    };

    fetchGlobalData();
  }, []);

  return (
    <Router>
      <ScrollToTop />

      {/* Navbar */}
      <AppNavbar
        contactInfo={apiData?.contact_info || []}
        socialLinks={apiData?.social_link || []}
      />

      <main style={{ marginTop: "80px" }}>
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />

            <Route
              path="/about"
              element={
                <PageLayout title="About Us">
                  <AboutPage />
                </PageLayout>
              }
            />

            <Route
              path="/services"
              element={
                <PageLayout title="Our Services">
                  <ServicesPage />
                </PageLayout>
              }
            />

            <Route
              path="/projects"
              element={
                <PageLayout title="Our Projects">
                  <ProjectsPage />
                </PageLayout>
              }
            />

            <Route
              path="/gallery"
              element={
                <PageLayout title="Gallery">
                  <GalleryPage />
                </PageLayout>
              }
            />

            <Route
              path="/careers"
              element={
                <PageLayout title="Careers">
                  <CareersPage />
                </PageLayout>
              }
            />

            <Route path="/contact" element={<Contact />} />

            {/* Admin Login */}
            <Route path="/admin/login" element={<Login />} />

            {/* Private Admin Routes */}
            <Route element={<PrivateRoute />}>
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Route>

            {/* --- 404 CATCH-ALL ROUTE --- */}
            {/* This must be the LAST route in the list */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>

      {/* Footer */}
      <Footer
        partners={apiData?.partner || []}
        footerServices={apiData?.footer_service || []}
        locations={apiData?.location || []}
      />
    </Router>
  );
}

export default App;
